import React from "react";

/**
 * V1.6 — Blueprint Legend overlay.
 * A signature-ready CAD title-block in the bottom-right corner of the 3D
 * viewport. Visible only when Drafting Mode is engaged (the parent gates
 * rendering). Fields: Date · Project Name · Scale.
 *
 * Style: monospace, dark-on-white CAD pill, with a faux drafting-frame
 * border so it reads as a stamp on a printed blueprint.
 */
export default function BlueprintLegend({ projectName, style, scale = "1:100" }) {
  const today = new Date();
  const dateStr = today.toISOString().slice(0, 10);
  return (
    <div
      data-testid="blueprint-legend"
      className="pointer-events-none absolute bottom-3 right-3 z-30 select-none"
      aria-hidden="true"
    >
      <div className="bg-white text-zinc-900 border-2 border-zinc-900 shadow-[0_4px_12px_rgba(0,0,0,0.35)] font-mono">
        <div className="px-3 py-1.5 border-b-2 border-zinc-900 bg-zinc-900 text-white text-[9px] tracking-widest uppercase">
          // Blueprint · Drafting Mode
        </div>
        <div className="grid grid-cols-3 divide-x-2 divide-zinc-900 text-[10px] uppercase tracking-wider">
          <div className="px-3 py-2">
            <div className="text-zinc-500 text-[8px]">Date</div>
            <div className="text-zinc-900 mt-0.5" data-testid="legend-date">
              {dateStr}
            </div>
          </div>
          <div className="px-3 py-2">
            <div className="text-zinc-500 text-[8px]">Project</div>
            <div
              className="text-zinc-900 mt-0.5 max-w-[180px] truncate"
              data-testid="legend-project"
              title={projectName || "Untitled"}
            >
              {projectName || "Untitled"}
            </div>
            {style && (
              <div className="text-zinc-500 text-[8px] mt-0.5 truncate">
                {style}
              </div>
            )}
          </div>
          <div className="px-3 py-2">
            <div className="text-zinc-500 text-[8px]">Scale</div>
            <div className="text-zinc-900 mt-0.5" data-testid="legend-scale">
              {scale}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
